// extracted by mini-css-extract-plugin
module.exports = {"advice-list-article_decline-reason":"_9e1425b4d3--advice-list-article_decline-reason--s53Z1"};